import type { PDCReportSchema } from "../types";
import {
    createDateColumn,
    createStringColumn,
    getMetadataValue,
    normalizeStringArray,
} from "./columnHelpers";
import { createLinkColumn } from "./linkColumnHelper";

const namespace = "pdc_reports";

const getUnitsFieldAsString = (row: PDCReportSchema, key: string): string => {
    const units = getMetadataValue(row, "metadata.Units");
    if (!Array.isArray(units) || units.length === 0) return normalizeStringArray();
    const firstUnit = units[0] as Record<string, string[] | undefined> | undefined;
    if (!firstUnit) return normalizeStringArray();
    return normalizeStringArray(firstUnit[key]);
};

export const pdcColumns = [
    createStringColumn<PDCReportSchema>({
        namespace,
        field: "metadata.ReportNumber",
        header: "Report Number",
    }),
    createStringColumn<PDCReportSchema>({
        namespace,
        field: "metadata.DistributionTitle",
        header: "Title",
    }),
    createStringColumn<PDCReportSchema>({
        namespace,
        field: "metadata.Units.CustomerName",
        header: "Customer Name",
        accessor: (row) => getUnitsFieldAsString(row, "CustomerName"),
    }),
    createDateColumn<PDCReportSchema>({
        namespace,
        field: "metadata.EventDate",
        header: "Event Date",
    }),
    createDateColumn<PDCReportSchema>({
        namespace,
        field: "metadata.CreatedDate",
        header: "Report Date",
    }),
    createStringColumn<PDCReportSchema>({
        namespace,
        field: "metadata.TurbineFrame",
        header: "Turbine Frame",
        accessor: (row) =>
            normalizeStringArray(
                getMetadataValue(row, "metadata.TurbineFrame") as string[] | undefined,
            ),
    }),
    createStringColumn<PDCReportSchema>({
        namespace,
        field: "metadata.Units.AEIC",
        header: "AEIC",
        accessor: (row) => getUnitsFieldAsString(row, "AEIC"),
    }),
    createStringColumn<PDCReportSchema>({
        namespace,
        field: "metadata.Units.TurbineShopOrderNumber",
        header: "Shop Order Number",
        accessor: (row) => getUnitsFieldAsString(row, "TurbineShopOrderNumber"),
    }),
    createStringColumn<PDCReportSchema>({
        namespace,
        field: "metadata.OperatingRisk",
        header: "Operating Risk",
    }),
    createStringColumn<PDCReportSchema>({
        namespace,
        field: "metadata.ReportType",
        header: "Report Type",
    }),
    createStringColumn<PDCReportSchema>({
        namespace,
        field: "metadata.HardwareRisk",
        header: "Hardware Risk",
    }),
    createLinkColumn<PDCReportSchema>({
        namespace,
        field: "metadata.url",
        header: "Source",
    }),
];
